import React from "react";
import styles from "./AddRFZOArticles.module.scss";
import MedicineSearchBar from "../../../../MedicineSearchBar/MedicineSearchBar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { rfzoTherapyActions } from "../../../../../store/rfzoTherapy-slice";
import ArticleItem from "../../../../ArticleItem/ArticleItem";

const AddRFZOArticles = ({ header }: any) => {
  const dispatch = useDispatch();
  const articlesForRFZO = useSelector(
    (state: RootState) => state.rfzoTherapy.articlesForRFZO
  );

  return (
    <div className={styles.AddRFZOArticles}>
      <div className={styles.header}>{header}</div>
      <MedicineSearchBar
        ariaLabel="Pretražite artikle"
        onSelect={(item) => {
          dispatch(rfzoTherapyActions.setSelectedItem(item));
          dispatch(rfzoTherapyActions.toggleAddItemModal(true));
        }}
      />
      {articlesForRFZO.map((article, index: number) => {
        return <ArticleItem article={article} key={index} xIcon />;
      })}
    </div>
  );
};

export default AddRFZOArticles;
